module.exports = __webpack_public_path__ + "html/section-success-stories-list_99af01f61376d5d84a2cd4367ad27477.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-success-stories-list.html
// module id = PNDN
// module chunks = 58